import dayjs from "dayjs";

export const FLOAT_PRECISION = 15;
export const FLOAT_LOW_PRECISION = 4;
export const FLOAT_MINIMUM_PRECISION = 2;
export const roundFloat = (value:number) => value != null ? Math.round(value) : null
export const ceilFloat = (value:number) => Math.ceil(value)
export const convertToFloatExponential = (value, row) => value != null ? (value > 0 ? value.toExponential(2) : 0) : ""
export const convertToFloatWithMinimumPrecision = (value:number) => value != null ? parseFloat(value.toFixed(FLOAT_MINIMUM_PRECISION)) : null
export const convertToFloatWithLowPrecision = (value:number) => value != null ? parseFloat(value.toFixed(FLOAT_LOW_PRECISION)) : null
export const convertToFloatWithDefaultPrecision = (value:number) => value != null ? parseFloat(value.toFixed(FLOAT_PRECISION)) : null
export const convertRowToFloatWithMinimumPrecision = (value) => (value != null ? parseFloat(value.toFixed(FLOAT_MINIMUM_PRECISION)) : null)
export const convertRowToFloatWithLowPrecision = (value) => (value != null ? parseFloat(value.toFixed(FLOAT_LOW_PRECISION)) : null)
export const convertRowToFloatWithLowPrecisionWithLocale = (value, row) => (value != null ? parseFloat(value.toFixed(FLOAT_LOW_PRECISION)).toLocaleString() : null)
export const convertRowToIntWithPrecisionWithLocale = (value, row) => (value != null ? Math.round(value).toLocaleString("fr-FR") : null)
export const convertToPercentageString = (value:number, decimals:number = 2) => value != null ? (value *100).toFixed(decimals) + "%" : ""
export const convertToPercentageNumber = (value:number) => value != null ? parseFloat((value *100).toFixed(3)) : 0
export const convertToKWithMinimumPrecision = (value:number) => value != null ? convertToFloatWithMinimumPrecision(value / 1000) : null
export const weekDiffBetweenDates = (dateBefore:string, dateAfter:string) => Math.round(dayjs(dateAfter).diff(dayjs(dateBefore), "days") / 7)

export const convertToFloatBasedOnUnit = (value, unit) => {
    if(!(typeof value.toFixed == "function"))
        return value;
    if(unit == "%") 
        return convertToPercentageNumber(value)
    else if (unit == "UFC/mL") 
        return convertToFloatExponential(value, null)
    else
        return convertToFloatWithLowPrecision(value)
}
export const applyConversionToFloatsOfObject = (obj, conversionFn = convertToFloatWithLowPrecision, exceptions) => {
    if(!obj)
        return null;

    let _obj = JSON.parse(JSON.stringify(obj));

    for(var key in _obj) {
        if (_obj.hasOwnProperty(key) && typeof _obj[key] == "number"){
            _obj[key] = conversionFn(_obj[key]);
        }
    }
    exceptions.forEach(exception => {
        _obj[exception.field] = exception.conversionFn(_obj[exception.field])
    });
    return _obj
}